<template>
    <div class="order-group-query">
        <!-- 页面标题 -->
        <div class="page-header">
            <h1>订单跟团查询</h1>
        </div>

        <div style="height: calc(100vh - 60px);overflow-y: auto;">
            <!-- 查询区域 -->
            <div class="query-section">
                <div class="query-container">
                    <div class="input-group">
                        <label>订单号：</label>
                        <el-input v-model="orderId" placeholder="请输入订单编号" clearable class="order-input" />
                    </div>
                    <el-button type="primary" @click="handleQuery" :disabled="!orderId || loading" class="query-btn">
                        {{ loading ? '查询中...' : '查询' }}
                    </el-button>
                </div>
            </div>

            <!-- 查询结果 -->
            <div v-if="queryResult" class="result-section">
                <div class="result-container">
                    <h3>查询结果</h3>
                    <div class="result-content">
                        <div v-if="queryResult.length === 0" class="no-result">
                            暂无相关订单
                        </div>
                        <div v-else class="result-list">
                            <div v-for="(item, index) in queryResult" :key="index" class="result-item">
                                <div class="result-row">
                                    <span class="label">商品名称：</span>
                                    <span class="value">{{ item.skuName }}</span>
                                </div>
                                <div class="result-row">
                                    <span class="label">下单时间：</span>
                                    <span class="value">{{ item.createTime}}</span>
                                </div>
                                <div class="result-row">
                                    <span class="label">商品数量：</span>
                                    <span class="value">{{ item.skuNum }}</span>
                                </div>
                                <div class="result-row">
                                    <span class="label">订单状态：</span>
                                    <span class="value">{{ getOrderStatus(item.validCode) }}</span>
                                </div>
                                <div class="result-row">
                                    <span class="label">推广位ID：</span>
                                    <span class="value">{{ item.positionId }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 查询须知 -->
            <div class="instructions-section">
                <div class="instructions-container">
                    <h2>订单查询须知</h2>
                    <ol class="instructions-list">
                        <li>订单编号查找-->我的-->全部的订单-->找到订单点进去-->复制订单编号</li>
                        <li>为保障您充分享受下单权益，建议下单10分钟后查询能否正常抓取，如查询结果为"暂无相关订单"即为无效订单，请尽快重拍。</li>
                        <li>订单仅展现已付款、已付定金、待付款状态的订单。</li>
                        <li>京东订单号可能存在更新的情况，请用京东平台后台最新订单号进行查询。</li>
                        <li>下单不可使用超级红包、京享礼金、京东e卡，以及任何返利软件，会导致订单无效。</li>
                        <li>请勿勾选非推荐商品合并付款，可能会导致订单无效。</li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'OrderGroupQuery',
    data() {
        return {
            positionId: '',
            orderId: '',
            loading: false,
            queryResult: null,
            positionIdFromUrl: false // 标记是否从URL获取
        }
    },
    computed: {
        // 判断推广位ID是否从URL获取
        isPositionIdFromUrl() {
            return this.positionId && this.positionIdFromUrl
        }
    },
    mounted() {
        // 从URL参数中获取推广位ID
        this.getPositionIdFromUrl()
    },
    methods: {
        // 从URL参数中获取推广位ID
        getPositionIdFromUrl() {
            const urlParams = new URLSearchParams(window.location.search)
            const positionId = urlParams.get('d')
            if (positionId) {
                this.positionId = positionId
                this.positionIdFromUrl = true
            }
        },
        async handleQuery() {
            if (!this.orderId.trim()) {
                this.$message.warning('请输入订单编号')
                return
            }

            this.loading = true
            this.queryResult = null

            try {
                // 调用新的订单跟团查询接口
                const response = await axios.post('/api/order-group-query', {
                    orderId: this.orderId.trim(),
                    positionId: this.positionId.trim() || null
                })

                if (response.data && response.data.success) {
                    this.queryResult = response.data.data || []
                    if (this.queryResult.length === 0) {
                        this.$message.info('暂无相关订单')
                    } else {
                        this.$message.success(`查询成功，找到 ${this.queryResult.length} 条订单`)
                    }
                } else {
                    this.$message.error('查询失败')
                    this.queryResult = []
                }
            } catch (error) {
                console.error('查询订单失败:', error)
                this.$message.error('查询失败')
                this.queryResult = []
            } finally {
                this.loading = false
            }
        },

        // 获取订单状态
        getOrderStatus(validCode) {
            const statusMap = {
                15: '待付款',
                16: '已付款',
                24: '已付定金',
            }
            return statusMap[validCode] || `状态码: ${validCode}`
        }
    }
}
</script>

<style scoped lang="scss">
.order-group-query {
    min-height: 100vh;
    background: #f5f5f5;
}

.page-header {
    background: #42b983;
    padding: 20px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    h1 {
        color: white;
        font-size: 28px;
        font-weight: bold;
        margin: 0;
    }
}

.query-section {
    padding: 30px 20px;
    background: white;
    margin: 0 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.query-container {
    display: flex;
    flex-direction: column;
    gap: 15px;
    max-width: 600px;
    margin: 0 auto;
}

.input-group {
    display: flex;
    gap: 8px;

    label {
        font-weight: 500;
        color: #333;
        font-size: 14px;
        white-space: nowrap;
    }
}

.url-tip {
    font-size: 12px;
    color: #42b983;
    font-style: italic;
    margin-top: 4px;
}

.position-input,
.order-input {
    ::v-deep .el-input__inner {
        height: 45px;
        font-size: 16px;
        border-radius: 6px;
        border: 2px solid #e1e5e9;

        &:focus {
            border-color: #42b983;
        }
    }
}

.query-btn {
    height: 45px;
    font-size: 16px;
    border-radius: 6px;
    background: #42b983;
    border-color: #42b983;

    &:hover {
        background: #42b983;
        border-color: #42b983;
    }

    &:disabled {
        background: #ccc;
        border-color: #ccc;
    }
}

.instructions-section {
    padding: 0px 15px 15px 15px;
}

.instructions-container {
    background: white;
    padding: 30px;
    border-radius: 8px;
    border: 2px dashed #e1e5e9;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    h2 {
        color: #333;
        font-size: 20px;
        font-weight: bold;
        margin: 0 0 20px 0;
    }
}

.instructions-list {
    color: #666;
    line-height: 1.8;
    margin: 0;
    padding-left: 20px;

    li {
        margin-bottom: 15px;

        &:last-child {
            margin-bottom: 0;
        }
    }
}

.result-section {
    padding: 0px 15px 15px 15px;
}

.result-container {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    h3 {
        color: #333;
        font-size: 18px;
        font-weight: bold;
        margin: 0 0 15px 0;
    }
}

.result-content {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 4px;
    border: 1px solid #e9ecef;
}

.no-result {
    text-align: center;
    color: #666;
    font-size: 16px;
    padding: 20px;
}

.result-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.result-item {
    background: white;
    padding: 15px;
    border-radius: 6px;
    border: 1px solid #e9ecef;
}

.result-row {
    display: flex;
    margin-bottom: 8px;

    &:last-child {
        margin-bottom: 0;
    }

    .label {
        font-weight: 500;
        color: #666;
        min-width: 80px;
    }

    .value {
        color: #333;
        flex: 1;
        word-break: break-all;
    }
}

/* 移动端适配 */
@media (max-width: 768px) {
    .page-header {
        padding: 15px;

        h1 {
            font-size: 20px;
        }
    }

    .query-section {
        margin: 15px;
        padding: 15px;
    }

    .instructions-section {
        padding: 0px 15px 15px 15px;
    }

    .instructions-container {
        padding: 20px;
    }

    .result-section {
        padding: 0px 15px 15px 15px;
    }

    .result-row {
        flex-direction: column;
        gap: 4px;

        .label {
            min-width: auto;
        }
    }
}
</style>
